import { ContextualField } from '../../../models/ContextualField';
import { PropertyType } from '../../../models/enum';

export const AlarmCategories: ContextualField = {
    modelName: 'alarmCategories',
    propertyType: PropertyType.AlarmCategories,
    label: 'Filter by category',
    propertyName: 'alarmCategoriesProperty',
    icon: 'fa-key'
};